import { Component, OnInit } from '@angular/core';
import { KeyValues5, LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-dummy-bill',
  templateUrl: './dummy-bill.component.html',
  styleUrls: ['./dummy-bill.component.scss']
})
export class DummyBillComponent implements OnInit {
  items: KeyValues5[] = []; frequencyInMilliSeconds: number = 3000; interval;
  constructor(public localService: LocalService) { }

  ngOnInit(): void {
    this.onLoad();
    this.startTimer();
  }

  onLoad() {
    this.items = [];
    for (var i = 0; i < 2; i++) {
      this.items.push({
        v1: this.localService.getRandomString(3, true),
        v2: this.localService.getRandomString(1, true),
        v3: this.localService.getRandomString(2, true) + "." + this.localService.getRandomString(2, true),
        v4: this.localService.getRandomString(2, true)
      } as KeyValues5);
    }
  }

  startTimer() {
    this.interval = setInterval(() => {
      this.onLoad();
    }, this.frequencyInMilliSeconds);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  getTotal(strQty: string, strPrice: string): number {
    return parseFloat(strQty) * parseFloat(strPrice);
  }

  getName(index: string): string {
    return this.localService.languageContent.startup['item_' + index];
  }

  getGrandTotal(): number {
    return this.items.map(x => parseFloat(x.v3) * parseFloat(x.v4)).reduce((sum, current) => sum + current, 0);
  }

}
